export {iconSvgMap} from './iconSvgMap';
export {iconUrlMap} from './iconUrlMap';
export {withUrlIcons} from './utils';
